import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=2e32503e&"
import script from "./PhoneField.vue?vue&type=script&lang=ts&"
export * from "./PhoneField.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports